import React from 'react';
import { Form } from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';
import { CreateWatchState } from './createWatchState/CreateWatchState';

export const CreateWatchPage: React.FC = () => {
	return (
		<CreateWatchState>
			<Form />
			<ModalWindows />
		</CreateWatchState>
	);
};
